export interface PanelModel {
  user: { id: string; username: string; role: "admin" | "user"; status: "active" | "disabled" };
  subscription: { active: boolean; validUntil: string; remainingDays: number; cycleDays: number; url: string; uuid: string | null };
  nodes: Array<{ id: string; label: string; country: string | null; status: string; last_health: string; last_checked_at: string | null }>;
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const { headers, ...requestOptions } = options;
  const response = await fetch(`/api${path}`, {
    credentials: "same-origin",
    ...requestOptions,
    headers: { "content-type": "application/json", ...(headers || {}) },
  });
  const isJson = response.headers.get("content-type")?.includes("application/json");
  if (!isJson) throw new Error("Control-plane API is unavailable");
  const data = await response.json() as T & { error?: string };
  if (!response.ok) throw new Error(data.error || "Request failed");
  return data;
}

export const demoModel: PanelModel = {
  user: { id: "demo-admin", username: "operator", role: "admin", status: "active" },
  subscription: { active: true, validUntil: "2026-10-12T11:00:00.000Z", remainingDays: 28, cycleDays: 30, url: "https://datausage.pages.dev/s/demo-token", uuid: "d82c31b2-4e66-491a-8e16-df5ad4b9cd4d" },
  nodes: [
    { id: "edge-sg-1", label: "Singapore edge", country: "Singapore", status: "active", last_health: "healthy", last_checked_at: "2026-09-14T11:58:00.000Z" },
    { id: "edge-fra-1", label: "Frankfurt edge", country: "Germany", status: "active", last_health: "healthy", last_checked_at: "2026-09-14T11:58:00.000Z" },
    { id: "import-nyc", label: "New York import", country: "United States", status: "maintenance", last_health: "unknown", last_checked_at: null },
  ],
};
